module.exports = __webpack_public_path__ + "static/media/yuan4.9cd17107.png";